import * as firebase from "firebase/app";
import "firebase/analytics";
import getUserIP from "lib/getuserip";
import { isMobile } from "lib/checkuseros";

const eventsList = {
    API_ERROR: "API_ERROR",
    LOGIN_EVENT: "LOGIN_EVENT",
    REGISTRATION_FIRST_STEP: "REGISTRATION_FIRST_STEP",
    REGISTRATION_SECOND_STEP: "REGISTRATION_SECOND_STEP",
    REGISTRATION_THIRD_STEP: "REGISTRATION_THIRD_STEP",
    SUCCESS_PAGE: "WEB_REGISTRATION_SUCCEEDED",
    CANCEL_SUBSCRIPTION: "CANCEL_SUBSCRIPTION",
    YAAD_EMPTY_TMP: "YAAD_EMPTY_TMP",
    EMAIL_VALIDATION_FAILED: "EMAIL_VALIDATION_FAILED",
    REGISTRATION_LOGIN: "REGISTRATION_LOGIN",
    REGISTRATION_ALREADY_EXIST: "REGISTRATION_ALREADY_EXIST",
    CHOOSE_PACKAGE_EVENT: "CHOOSE_PACKAGE_EVENT",
    LANDING_PAGE_LOAD: "LANDING_PAGE_LOAD",
    REGISTRATION_SELECT_PACKAGE: "REGISTRATION_SELECT_PACKAGE",

    // ------------------ NEW REGISTRATION ------------------- //

    NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_PARENT:
      "New_Registration_Step_1_Parent",
    NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_KID:
      "New_Registration_Step_1_Kid",
    NEW_REGISTRATION_STEP_1_EXIT: "New_Registration_Step_1_Exit",
    NEW_REGISTRATION_START: "New_Registration_Start",

    NEW_REGISTRATION_STEP_2_VALIDATION: "New_Registration_Step_2_Validation",
    NEW_REGISTRATION_STEP_2_ERROR: "New_Registration_Step_2_Error",
    NEW_REGISTRATION_STEP_2_BACK: "New_Registration_Step_2_Back",
    NEW_REGISTRATION_STEP_2_EXIT: "New_Registration_Step_2_Exit",

    NEW_REGISTRATION_STEP_5_SUCCESS: "New_Registration_Step_5_Success",
    NEW_REGISTRATION_STEP_5_WRONG_EMAIL: "New_Registration_Step_5_Wrong_Email",
    NEW_REGISTRATION_STEP_5_NOT_VALID_EMAIL:
      "New_Registration_Step_5_Not_Valid_Email",
    NEW_REGISTRATION_STEP_5_WRONG_PASSWORD:
      "New_Registration_Step_5_Wrong_Password",
    NEW_REGISTRATION_STEP_5_VISIABLE_PASSWORD:
      "New_Registration_Step_5_Visiable_Password",
    NEW_REGISTRATION_STEP_5_UNVISIABLE_PASSWORD:
      "New_Registration_Step_5_Unvisiable_Password",
    NEW_REGISTRATION_STEP_5_TC_CHECKED: "New_Registration_Step_5_T&C_Checked",
    NEW_REGISTRATION_STEP_5_TC_UNCHECKED:
      "New_Registration_Step_5_T&C_Unchecked",
    NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_CHECKED:
      "New_Registration_Step_5_Marketing_Email_Checked",
    NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_UNCHECKED:
      "New_Registration_Step_5_Marketing_Email_Unchecked",
    NEW_REGISTRATION_STEP_5_EXIT: "New_Registration_Step_5_Exit",

    NEW_REGISTRATION_STEP_6_FREE_PACKAGE:
      "New_Registration_Step_6_Free_Package",
    NEW_REGISTRATION_STEP_6_BIGI_PLUS: "New_Registration_Step_6_BIGI+",

    NEW_REGISTRATION_STEP_9_ACHIEVED: "New_Registration_Step_9_Achieved",

    USER_CLICKED_IN_REGISTRATION: "USER_CLICKED_IN_REGISTRATION",
    NEW_USER_CREATED: "NEW_USER_CREATED",
    SUBSCRIPTION_PURCHASED: "SUBSCRIPTION_PURCHASED",
  },
  deviceTypes = {
    mobile: "mobile",
    browser: "browser",
  };

const getDeviceID = () => localStorage["uniqueDeviceID"];
const getDeviceType = () =>
  isMobile() ? deviceTypes.mobile : deviceTypes.browser;
const getUserName = () => localStorage["user.userName"] || "";
const getUserID = () => localStorage["user.id"] || "";

const getDefaultOptions = () => ({
  bigi_time_stamp: new Date(),
  bigi_device_id: getDeviceID(),
  bigi_user_ip: getUserIP(),
  bigi_device_type: getDeviceType(),
  bigi_user_name: getUserName(),
  bigi_user_id: getUserID(),
});

class AnalyticsEventsManager {
  constructor() {
    this.analytics = firebase.analytics();
    this.defaultOptions = getDefaultOptions();
  }

  sendLoginEvent({ userName, userID }) {
    this.analytics.logEvent(eventsList.LOGIN_EVENT, {
      ...this.defaultOptions,
      method: "BY_EMAIL",
      bigi_user_name: userName,
      bigi_user_id: userID,
    });
  }

  sendApiErrorEvent({ message, code, userName }) {
    this.analytics.logEvent(eventsList.API_ERROR, {
      bigi_API_error_message: message,
      bigi_API_error_code: String(code),
      ...this.defaultOptions,
      bigi_user_name: userName ? userName : this.defaultOptions.bigi_user_name,
    });
  }

  sendYaadEmptyTmpEvent({ tmp }) {
    this.analytics.logEvent(eventsList.YAAD_EMPTY_TMP, {
      YAAD_tmp_value: tmp,
      ...this.defaultOptions,
    });
  }

  sendFirstStepRegistrationEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_FIRST_STEP, {
      ...this.defaultOptions,
    });
  }

  sendSelectPackagePageLoadedEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_SELECT_PACKAGE, {
      ...this.defaultOptions,
    });
  }

  sendLandingPageLoadedEvent() {
    this.analytics.logEvent(eventsList.LANDING_PAGE_LOAD, {
      ...this.defaultOptions,
    });
  }

  sendSecondStepRegistrationEvent({ userName }) {
    this.analytics.logEvent(eventsList.REGISTRATION_SECOND_STEP, {
      ...this.defaultOptions,
      bigi_user_name: userName,
    });
  }

  sendThirdStepRegistrationEvent({ userName }) {
    this.analytics.logEvent(eventsList.REGISTRATION_THIRD_STEP, {
      ...this.defaultOptions,
      bigi_user_name: userName,
    });
  }

  sendSuccessPageEvent() {
    this.analytics.logEvent(eventsList.SUCCESS_PAGE, {
      ...this.defaultOptions,
    });
  }

  sendCalcelSubscriptionEvent() {
    this.analytics.logEvent(eventsList.CANCEL_SUBSCRIPTION, {
      ...this.defaultOptions,
    });
  }

  sendEmailValidationFailed({ userEmail }) {
    this.analytics.logEvent(eventsList.EMAIL_VALIDATION_FAILED, {
      ...this.defaultOptions,
      bigi_user_email: userEmail,
    });
  }

  sendRegistrationLoginButtonPressedEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_LOGIN, {});
  }

  sendUserAlreadyExistEvent(userEmail) {
    this.analytics.logEvent(eventsList.REGISTRATION_ALREADY_EXIST, {
      bigi_user_email: userEmail,
    });
  }

  sendChoosePackageEvent(userName) {
    this.analytics.logEvent(eventsList.CHOOSE_PACKAGE_EVENT, {
      ...this.defaultOptions,
      gaEventCategory: "Registration Process",
      gaEventLabel: "Package Page",
      gaEventAction: "CHOOSE_PACKAGE_EVENT",
      gaPageviewPath: "/registrationProcess/step2.2-ChosePackage",
      bigi_user_name: userName,
    });
  }

  sendFromLPToRegistrationStep2Event() {
    this.analytics.logEvent(eventsList.REGISTRATION_SECOND_STEP, {
      ...this.defaultOptions,
      gaEventCategory: "Registration Process",
      gaEventLabel: "Upgrade",
      gaEventAction: "REGISTRATION_SECOND_STEP",
      gaPageviewPath: "/registrationProcess/step2.1-UpgradeToPayment",
    });
  }

  sendFromChoosePackageToRegistrationSecondStepEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_SECOND_STEP, {
      ...this.defaultOptions,
      gaEventCategory: "Registration Process",
      gaEventLabel: "-",
      gaEventAction: "REGISTRATION_SECOND_STEP",
      gaPageviewPath: "/registrationProcess/step2.2-address",
    });
  }

  sendFromSettingsPageToRegistrationSecondStepEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_SECOND_STEP, {
      ...this.defaultOptions,
      gaEventCategory: "Settings Page",
      gaEventLabel: "-",
      gaEventAction: "REGISTRATION_SECOND_STEP",
      gaPageviewPath: "/registrationProcess/step3.1-updatePayment",
    });
  }

  sendFromSettingsPageToRegistrationThirdStepEvent() {
    this.analytics.logEvent(eventsList.REGISTRATION_THIRD_STEP, {
      ...this.defaultOptions,
      gaEventCategory: "Settings Page",
      gaEventLabel: "-",
      gaEventAction: "REGISTRATION_THIRD_STEP",
      gaPageviewPath: "/registrationProcess/step2.3-UpgradeToPayment",
    });
  }

  // ------------------ NEW REGISTRATION ------------------- //

  newRegistrationBack(step) {
    if (eventsList[`NEW_REGISTRATION_STEP_${step}_BACK`]) {
      this.analytics.logEvent(
        eventsList[`NEW_REGISTRATION_STEP_${step}_BACK`],
        {
          ...this.defaultOptions,
        }
      );
    }
  }

  // Step 1
  newRegistrationSendUserType(userType) {
    const {
      NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_KID,
      NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_PARENT,
    } = eventsList;
    const eventType =
      userType === "KID"
        ? NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_KID
        : NEW_REGISTRATION_STEP_1_SEND_USER_TYPE_AS_PARENT;

    this.analytics.logEvent(eventType, {
      ...this.defaultOptions,
      gaEventAction: eventType,
    });
  }

  newRegistrationExit(step) {
    const event = eventsList[`NEW_REGISTRATION_STEP_${step}_EXIT`];

    if (event) {
      this.analytics.logEvent(event, {
        ...this.defaultOptions,
        gaEventAction: event,
      });
    }
  }

  newRegistrationStart() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_START, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_START,
    });
  }

  // Step 2
  newRegistrationStep_2Validation() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_2_VALIDATION, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_2_VALIDATION,
    });
  }

  newRegistrationStep_2Error() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_2_ERROR, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_2_ERROR,
    });
  }

  // Ster 3
  newRegistrationStep_5Success() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_5_SUCCESS, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_SUCCESS,
    });
  }

  newRegistrationStep_5WrongEmail() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_5_WRONG_EMAIL, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_WRONG_EMAIL,
    });
  }

  newRegistrationStep_5NotValidEmail() {
    this.analytics.logEvent(
      eventsList.NEW_REGISTRATION_STEP_5_NOT_VALID_EMAIL,
      {
        ...this.defaultOptions,
        gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_NOT_VALID_EMAIL,
      }
    );
  }

  newRegistrationStep_5WrongPassword() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_5_WRONG_PASSWORD, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_WRONG_PASSWORD,
    });
  }

  newRegistrationStep_5VisiablePassword() {
    this.analytics.logEvent(
      eventsList.NEW_REGISTRATION_STEP_5_VISIABLE_PASSWORD,
      {
        ...this.defaultOptions,
        gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_VISIABLE_PASSWORD,
      }
    );
  }

  newRegistrationStep_5UnvisiablePassword() {
    this.analytics.logEvent(
      eventsList.NEW_REGISTRATION_STEP_5_UNVISIABLE_PASSWORD,
      {
        ...this.defaultOptions,
        gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_UNVISIABLE_PASSWORD,
      }
    );
  }

  newRegistrationStep_5TcChecked() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_5_TC_CHECKED, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_TC_CHECKED,
    });
  }

  newRegistrationStep_5TcUnchecked() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_5_TC_UNCHECKED, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_5_TC_UNCHECKED,
    });
  }

  newRegistrationStep_5MarketingEmailChecked() {
    this.analytics.logEvent(
      eventsList.NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_CHECKED,
      {
        ...this.defaultOptions,
        gaEventAction:
          eventsList.NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_CHECKED,
      }
    );
  }

  newRegistrationStep_5MarketingEmailUnchecked() {
    this.analytics.logEvent(
      eventsList.NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_UNCHECKED,
      {
        ...this.defaultOptions,
        gaEventAction:
          eventsList.NEW_REGISTRATION_STEP_5_MARKETING_EMAIL_UNCHECKED,
      }
    );
  }

  newRegistrationStep_6FreePackage() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_6_FREE_PACKAGE, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_6_FREE_PACKAGE,
    });
  }
  newRegistrationStep_6BigiPlus() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_6_BIGI_PLUS, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_6_BIGI_PLUS,
    });
  }
  newRegistrationStep_9Achieved() {
    this.analytics.logEvent(eventsList.NEW_REGISTRATION_STEP_9_ACHIEVED, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_REGISTRATION_STEP_9_ACHIEVED,
    });
  }

  userClickedInRegistration() {
    this.analytics.logEvent(eventsList.USER_CLICKED_IN_REGISTRATION, {
      ...this.defaultOptions,
      gaEventAction: eventsList.USER_CLICKED_IN_REGISTRATION,
    });
  }
  newUserCreated() {
    this.analytics.logEvent(eventsList.NEW_USER_CREATED, {
      ...this.defaultOptions,
      gaEventAction: eventsList.NEW_USER_CREATED,
    });
  }
  subscriptionPurchased() {
    this.analytics.logEvent(eventsList.SUBSCRIPTION_PURCHASED, {
      ...this.defaultOptions,
      gaEventAction: eventsList.SUBSCRIPTION_PURCHASED,
      in_app_purchase: "Yaad",
    });
  }
}

export default AnalyticsEventsManager;



// WEBPACK FOOTER //
// ./src/js/utils/firebase/index.js